module.exports = __webpack_public_path__ + "static/media/nchicago.e277266a.png";